(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.productData = null;
  }

  connectedCallback() {
    this.sectionId = this.dataset.section;
    this.productUrl = this.dataset.url;
    this.initVariantData();
    this.initVariantMediaMap();
  }

  initVariantData() {
    const dataEl = this.querySelector('[data-selected-variant]');
    if (dataEl) {
      try {
        this.currentVariant = JSON.parse(dataEl.textContent);
      } catch (e) {
        console.error('Error parsing variant data:', e);
      }
    }
  }

  onVariantChange(event) {
    const target = event.target;
    if (!target.matches('input[type="radio"], select')) return;

    this.updateSelectedValue(target);
    this.updateVariantByOptions();
  }

  updateSelectedValue(target) {
    const fieldset = target.closest('.variant-picker__option');
    if (!fieldset) return;

    const valueDisplay = fieldset.querySelector('.variant-picker__option-value');
    if (valueDisplay) {
      valueDisplay.textContent = target.value;
    }
  }

  getSelectedOptions() {
    const options = [];
    this.querySelectorAll('.variant-picker__option').forEach((fieldset) => {
      const radio = fieldset.querySelector('input[type="radio"]:checked');
      const select = fieldset.querySelector('select');
      
      if (radio) {
        options.push(radio.value);
      } else if (select) {
        options.push(select.value);
      }
    });
    return options;
  }

  getSelectedOptionValueIds() {
    const ids = [];
    this.querySelectorAll('.variant-picker__option').forEach((fieldset) => {
      const radio = fieldset.querySelector('input[type="radio"]:checked');
      const select = fieldset.querySelector('select');
      
      if (radio && radio.dataset.optionValueId) {
        ids.push(radio.dataset.optionValueId);
      } else if (select) {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          ids.push(selectedOption.dataset.optionValueId);
        }
      }
    });
    return ids;
  }

  updateVariantByOptions() {
    const selectedOptionValueIds = this.getSelectedOptionValueIds();
    
    if (selectedOptionValueIds.length === 0) return;

    const params = new URLSearchParams();
    params.set('section_id', this.sectionId);
    params.set('option_values', selectedOptionValueIds.join(','));

    const url = `${this.productUrl}?${params.toString()}`;

    fetch(url)
      .then(response => response.text())
      .then(html => {
        this.updatePageContent(html, selectedOptionValueIds);
      })
      .catch(err => {
        console.error('Error fetching variant:', err);
      });
  }

  updatePageContent(html, selectedOptionValueIds) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // Update variant picker availability
    this.updateVariantAvailability(doc);

    // Update price display
    this.updatePrice(doc);

    // Update add to cart button
    this.updateAddToCartButton(doc);

    // Update hidden variant input
    this.updateHiddenInput(doc);

    // Update product image to match variant
    this.updateProductImage(doc);

    // Update URL
    if (this.dataset.updateUrl === 'true') {
      this.updateURL(selectedOptionValueIds);
    }

    // Dispatch custom event for other components
    this.dispatchEvent(new CustomEvent('variant:changed', {
      bubbles: true,
      detail: { sectionId: this.sectionId }
    }));
  }

  updateVariantAvailability(doc) {
    const newPicker = doc.querySelector('.variant-picker');
    if (!newPicker) return;

    this.querySelectorAll('.variant-picker__option').forEach((fieldset, index) => {
      const newFieldset = newPicker.querySelectorAll('.variant-picker__option')[index];
      if (!newFieldset) return;

      // Update radio button states
      fieldset.querySelectorAll('input[type="radio"]').forEach(input => {
        const newInput = newFieldset.querySelector(`input[value="${CSS.escape(input.value)}"]`);
        if (newInput) {
          const newLabel = newInput.nextElementSibling;
          const currentLabel = input.nextElementSibling;
          
          if (newInput.dataset.unavailable === 'true') {
            currentLabel.classList.add('variant-picker__label--unavailable');
            if (!currentLabel.querySelector('.variant-picker__unavailable-indicator')) {
              const indicator = document.createElement('span');
              indicator.className = 'variant-picker__unavailable-indicator';
              indicator.setAttribute('aria-hidden', 'true');
              currentLabel.appendChild(indicator);
            }
          } else {
            currentLabel.classList.remove('variant-picker__label--unavailable');
            const indicator = currentLabel.querySelector('.variant-picker__unavailable-indicator');
            if (indicator) indicator.remove();
          }
        }
      });

      // Update select option states
      fieldset.querySelectorAll('select option').forEach(option => {
        const newOption = newFieldset.querySelector(`select option[value="${CSS.escape(option.value)}"]`);
        if (newOption) {
          option.disabled = newOption.disabled;
          option.textContent = newOption.textContent;
        }
      });
    });
  }

  updatePrice(doc) {
    const newPrice = doc.querySelector('[data-price-wrapper]');
    const currentPrice = document.querySelector('[data-price-wrapper]');
    if (newPrice && currentPrice) {
      currentPrice.innerHTML = newPrice.innerHTML;
    }
  }

  updateAddToCartButton(doc) {
    const newButton = doc.querySelector('[data-add-to-cart]');
    const currentButton = document.querySelector('[data-add-to-cart]');
    if (newButton && currentButton) {
      currentButton.disabled = newButton.disabled;
      const newText = newButton.querySelector('[data-add-to-cart-text]');
      const currentText = currentButton.querySelector('[data-add-to-cart-text]');
      if (newText && currentText) {
        currentText.innerHTML = newText.innerHTML;
      }
    }
  }

  updateHiddenInput(doc) {
    const newInput = doc.querySelector('input.product-variant-id, input[name="id"]');
    const currentInputs = document.querySelectorAll(`form[id^="product-form-${this.sectionId}"] input[name="id"], .product-variant-id`);
    
    if (newInput) {
      currentInputs.forEach(input => {
        input.value = newInput.value;
        input.disabled = newInput.disabled;
      });
    }
  }

  initVariantMediaMap() {
    // Load variant-to-media mapping from product gallery
    const mapScript = document.querySelector('[data-variant-media-map]');
    if (mapScript) {
      try {
        this.variantMediaMap = JSON.parse(mapScript.textContent);
      } catch (e) {
        console.error('[VariantPicker] Error parsing variant media map:', e);
        this.variantMediaMap = null;
      }
    } else {
      this.variantMediaMap = null;
    }
  }

  updateProductImage(doc) {
    // Get variant data from the new HTML
    const newVariantData = doc.querySelector('[data-selected-variant]');
    if (!newVariantData) {
      // Try alternative: find visible image in fetched gallery
      this.updateImageFromFetchedGallery(doc);
      return;
    }

    let variant;
    try {
      variant = JSON.parse(newVariantData.textContent);
    } catch (e) {
      console.error('[VariantPicker] Error parsing variant data:', e);
      return;
    }

    if (!variant || !variant.id) return;

    // Method 1: Use the variant-to-media mapping (most reliable)
    const variantId = String(variant.id);
    if (this.variantMediaMap) {
      const mediaId = this.variantMediaMap[variantId] || this.variantMediaMap[variant.id];
      if (mediaId) {
        this.switchToMedia(mediaId);
        return;
      }
    }

    // Method 2: Try featured_media from variant JSON
    if (variant.featured_media && variant.featured_media.id) {
      this.switchToMedia(variant.featured_media.id);
      return;
    }

    // Method 3: Find the visible image in the fetched HTML gallery
    this.updateImageFromFetchedGallery(doc);
  }

  updateImageFromFetchedGallery(doc) {
    // Find the visible media in the fetched HTML
    const fetchedGallery = doc.querySelector('[data-product-gallery]');
    if (!fetchedGallery) return;

    const visibleMedia = fetchedGallery.querySelector('[data-main-media].is-visible');
    if (visibleMedia && visibleMedia.dataset.mediaId) {
      this.switchToMedia(visibleMedia.dataset.mediaId);
    } else {
      // Try first media if none marked visible
      const firstMedia = fetchedGallery.querySelector('[data-main-media]');
      if (firstMedia && firstMedia.dataset.mediaId) {
        this.switchToMedia(firstMedia.dataset.mediaId);
      }
    }
  }

  switchToMedia(mediaId) {
    // Find the product gallery
    const gallery = document.querySelector('[data-product-gallery]');
    if (!gallery || !mediaId) return;

    const targetMediaId = String(mediaId);

    // Hide all main media and show the one matching the variant
    const mainMediaWrappers = gallery.querySelectorAll('[data-main-media]');
    let foundMatch = false;

    mainMediaWrappers.forEach(mediaWrapper => {
      const wrapperMediaId = mediaWrapper.dataset.mediaId;
      if (wrapperMediaId === targetMediaId) {
        mediaWrapper.classList.remove('is-hidden');
        mediaWrapper.classList.add('is-visible');
        foundMatch = true;
      } else {
        mediaWrapper.classList.remove('is-visible');
        mediaWrapper.classList.add('is-hidden');
      }
    });

    // If no match found by ID, try finding by index via ProductImageGallery instance
    if (!foundMatch && gallery.productImageGallery) {
      let targetIndex = -1;
      mainMediaWrappers.forEach((wrapper, index) => {
        if (wrapper.dataset.mediaId === targetMediaId) {
          targetIndex = index;
        }
      });
      if (targetIndex >= 0) {
        gallery.productImageGallery.selectImage(targetIndex);
        return;
      }
    }

    // Update thumbnail active state
    const thumbnails = gallery.querySelectorAll('[data-thumbnail-trigger]');
    let activeThumbnail = null;
    
    thumbnails.forEach(thumbnail => {
      const thumbMediaId = thumbnail.dataset.mediaId;
      if (thumbMediaId === targetMediaId) {
        thumbnail.classList.add('is-active');
        activeThumbnail = thumbnail;
      } else {
        thumbnail.classList.remove('is-active');
      }
    });

    // Scroll active thumbnail into view
    if (activeThumbnail) {
      const thumbnailsContainer = gallery.querySelector('.product-image-gallery__thumbnails');
      if (thumbnailsContainer) {
        activeThumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
  }

  updateURL(selectedOptionValueIds) {
    if (!selectedOptionValueIds.length) return;
    
    const url = new URL(window.location);
    url.searchParams.set('option_values', selectedOptionValueIds.join(','));
    url.searchParams.delete('variant');
    window.history.replaceState({}, '', url);
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}
  } catch(e) { console.error(e); }
})();

})();
